import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { ApiService } from "../api/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class NotAuthenticatedGuard implements CanActivate {
    constructor(
        private api: ApiService,
        private router: Router
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.api.auth.isLoggedIn().pipe(
            map((loggedIn) => {
                if (loggedIn) {
                    return this.router.createUrlTree(["/dashboard"]);
                }
                return true;
            })
        );
    }
}
